import { App } from "@capacitor/app";
import { AppLauncher } from "@capacitor/app-launcher";
import van from "vanjs-core";
import { router } from "..";
import { getBillingUrl } from "../api/users_{userId}_billing";
import { assets, config } from "../app-env/common";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { onMobile } from "../mobile";
import { state } from "../state";
import { Bulma } from "./bulma";

function openBillingPortal() {
	const promise = onMobile
		? openBillingPortalMobile()
		: openBillingPortalWeb();
	loadingScreen.waitFor(promise);
}

async function openBillingPortalMobile() {
	const appUri = encodeURIComponent(`${(await App.getInfo()).id}://`);
	const returnUrl = `${config.baseUrl}/redirect?uri=${appUri}`;
	const billingUrl = await getBillingUrl(returnUrl);
	AppLauncher.openUrl({ url: billingUrl }).catch(() =>
		window.open(billingUrl, "_blank"),
	);
}

async function openBillingPortalWeb() {
	const billingUrl = await getBillingUrl(undefined);
	window.open(billingUrl, "_blank");
}

/**
 * @param {string} theme
 * @returns
 */
async function navbar(theme) {
	const isSignedIn = await state.isSignedIn();
	const user = await state.getSignedInUser();

	return Bulma.navbar({
		theme: theme,
		brand: [
			Bulma.navbarItem(
				{},
				van.tags.figure(
					{
						class: "image",
					},
					van.tags.img({
						src: assets["logo.png"],
					}),
				),
			),
		],
		start: [
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: () => router.jump("/devices"),
				},
				t.devices,
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: () => router.jump("/account"),
				},
				t.account,
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: openBillingPortal,
				},
				t.billing,
			),
			Bulma.navbarItem(
				{
					href: t.supportUrl,
					target: "_blank",
				},
				"Support",
			),
		],
		end: [
			Bulma.navbarItem(
				{
					hidden: user.AccountType !== "admin",
					onClick: () => router.jump("/admin"),
				},
				"Admin",
			),
			Bulma.navbarDropdown(
				t.language,
				setLocaleNavbarItem("English", "en-GB"),
				setLocaleNavbarItem("Deutsch", "de-DE"),
				setLocaleNavbarItem("Français", "fr-FR"),
				setLocaleNavbarItem("Svenska", "sv-SE"),
			),
			Bulma.navbarItem(
				{
					hidden: isSignedIn,
					onClick: () => router.jump("/sign-in"),
				},
				t.signIn,
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn || state.isImpersonating(),
					onClick: signOut,
				},
				t.signOut,
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn || !state.isImpersonating(),
					onClick: stopImpersonating,
				},
				"Stop impersonating",
			),
		],
	});
}

/**
 * @param {string} text
 * @param {Locale} id
 */
function setLocaleNavbarItem(text, id) {
	const setLocale = async () => {
		const user = await state.getSignedInUser();
		user.Locale = id;
		await state.setUser(user);
		state.loadUserLocale();
		location.reload();
	};

	return Bulma.navbarItem(
		{
			onClick: setLocale,
		},
		text,
	);
}

async function signOut() {
	await state.signOut();
	router.jump("/sign-in");
}

async function stopImpersonating() {
	const user = await state.getActiveUser();
	await state.stopImpersonating();
	router.jump(`/admin/user/${user.Id}`);
}

export { navbar };
